module.exports = __webpack_public_path__ + "img/lg_ring_g_l_null_0@2x.59975def.png";